export const summaryCards = [
  {
    title: "Total Attack Patterns",
    value: "1,247",
    meta: "known signatures",
    tone: "primary",
  },
  {
    title: "AI Coverage",
    value: "88%",
    meta: "1,097 patterns",
    tone: "success",
    progress: 88,
    delta: "-2% vs 30d",
  },
  {
    title: "Detection Gaps",
    value: "12%",
    meta: "150 blindspots",
    tone: "warning",
    delta: "-2% vs 30d",
  },
  {
    title: "Models Deployed",
    value: "23",
    meta: "active detectors",
    tone: "info",
    status: "All operational",
  },
];

export const blindspotCards = [
  {
    title: "Zero-Day Obfuscation",
    tag: "critical",
    count: "47 patterns",
    intensity: 94,
    summary:
      "Signature-based matching fails against novel obfuscation. Models M-14, M-19, M-22 lack behavioral heuristics for polymorphic patterns.",
    tags: ["Neural-Scribe v2.1", "Pattern-Guard", "SCADA-Shield"],
  },
  {
    title: "Encrypted Tunneling",
    tag: "high",
    count: "58 patterns",
    intensity: 78,
    summary:
      "TLS 1.3 encrypted C2 channels bypass DPI. DNS-over-HTTPS exfiltration undetected due to certificate pinning.",
    tags: ["Modbus-Guardian v4", "DNP3-Analyzer", "Tunnel-Watch"],
  },
];

export const activeModels = [
  {
    name: "Modbus-Guardian v4",
    meta: "Protocol • 342 patterns",
    accuracy: "96.8%",
    status: "healthy",
  },
  {
    name: "Neural-Scribe v2.3",
    meta: "ML • 287 patterns",
    accuracy: "94.2%",
    status: "healthy",
  },
  {
    name: "SCADA-Shield Pro",
    meta: "Signature • 198 patterns",
    accuracy: "93.7%",
    status: "healthy",
  },
  {
    name: "DNP3-Analyzer",
    meta: "Protocol • 156 patterns",
    accuracy: "91.4%",
    status: "warning",
  },
  {
    name: "Modbus-Guardian v2",
    meta: "Protocol • 324 patterns",
    accuracy: "96.8%",
    status: "healthy",
  },
  {
    name: "Anomaly-Hunter v3",
    meta: "ML • 114 patterns",
    accuracy: "89.9%",
    status: "healthy",
  },
];

export const remediationRoadmap = [
  {
    phase: "Phase 1",
    timeline: "Current",
    title: "Data Labeling",
    summary:
      "Labeling 2,847 SCADA protocol variants. Focus on IEC 61850 GOOSE and Siemens S7.",
    progress: 72,
    items: [
      "Modbus edge cases",
      "Encrypted payloads",
      "Firmware samples",
    ],
    tone: "primary",
  },
  {
    phase: "Phase 2",
    timeline: "14 Days",
    title: "Synthetic Training",
    summary:
      "Generate 50K synthetic attacks via GAN. Train 4 new models.",
    items: ["GAN training", "Scenario generation", "Model validation"],
    tone: "neutral",
  },
  {
    phase: "Phase 3",
    timeline: "30 Days",
    title: "Deployment v2.5",
    summary:
      "Deploy to reduce gap from 12% to 4%. A/B testing with shadow deployment.",
    items: ["Shadow deploy", "A/B testing", "Full rollout"],
    tone: "neutral",
  },
];

export const patternLog = [
  {
    id: "#PAT-842",
    detProb: "14%",
    model: "Tunnel-Watch v1",
    gapReason: "TLS 1.3 Encryption",
    category: "Encrypted Tunneling",
    status: "New",
    date: "2025-12-18",
  },
  {
    id: "#PAT-856",
    detProb: "8%",
    model: "DNP3-Analyzer",
    gapReason: "Protocol Encapsulation",
    category: "Encrypted Tunneling",
    status: "New",
    date: "2025-12-18",
  },
  {
    id: "#PAT-901",
    detProb: "0%",
    model: "Pending",
    gapReason: "New Signature",
    category: "Zero-Day",
    status: "Pending",
    date: "2025-12-17",
  },
  {
    id: "#PAT-912",
    detProb: "5%",
    model: "Pattern-Guard",
    gapReason: "Polymorphic Code",
    category: "Zero-Day",
    status: "New",
    date: "2025-12-17",
  },
  {
    id: "#PAT-934",
    detProb: "3%",
    model: "Firmware-Sentinel",
    gapReason: "ARM Cortex Variant",
    category: "Polymorphic",
    status: "New",
    date: "2025-12-16",
  },
  {
    id: "#PAT-945",
    detProb: "0%",
    model: "Pending",
    gapReason: "Packed Binary",
    category: "Polymorphic",
    status: "Pending",
    date: "2025-12-16",
  },
  {
    id: "#PAT-967",
    detProb: "19%",
    model: "ICS-Defender",
    gapReason: "Memory Injection",
    category: "Zero-Day",
    status: "New",
    date: "2025-12-15",
  },
  {
    id: "#PAT-978",
    detProb: "0%",
    model: "Pending",
    gapReason: "Novel Technique",
    category: "Encrypted Tunneling",
    status: "Pending",
    date: "2025-12-15",
  },
  {
    id: "#PAT-989",
    detProb: "12%",
    model: "SCADA-Shield Pro",
    gapReason: "Protocol Abuse",
    category: "Zero-Day",
    status: "New",
    date: "2025-12-14",
  },
  {
    id: "#PAT-1023",
    detProb: "16%",
    model: "Tunnel-Watch v1",
    gapReason: "Cert Pinning",
    category: "Encrypted Tunneling",
    status: "New",
    date: "2025-12-14",
  },
];
